"use strict";
/*
 * Created on 26. 1. 2021
 *
 * Copyright (c) 2021 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DateParser_1 = require("../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var DashboardPromoType_1 = require("../sales-dashboard/DashboardPromoType");
/**
 * @author Tomas Leity
 */


var SalesDashboardComparatorRowDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SalesDashboardComparatorRowDTO, _DomainObject_1$Domai);

  /**
   * @param id
   * @param reportId
   * @param reportTime
   * @param categoryId
   * @param volumeDiff
   * @param costValueDiff
   * @param title
   * @param promoType
   * @param simulation
   * @param volumeSDR
   * @param volumePPR
   * @param costValueSDR
   * @param costValuePPR
   */
  function SalesDashboardComparatorRowDTO(id,
  /** Additional row information */
  reportId, reportTime, categoryId,
  /** {@link SalesDashboardComparatorItem} params */
  volumeDiff, costValueDiff, title, promoType, simulation, volumeSDR, volumePPR, costValueSDR, costValuePPR) {
    var _this;

    _classCallCheck(this, SalesDashboardComparatorRowDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SalesDashboardComparatorRowDTO).call(this));
    _this.id = id;
    _this.reportId = reportId;
    _this.reportTime = reportTime;
    _this.categoryId = categoryId;
    _this.volumeDiff = volumeDiff;
    _this.costValueDiff = costValueDiff;
    _this.title = title;
    _this.promoType = promoType;
    _this.simulation = simulation;
    _this.volumeSDR = volumeSDR;
    _this.volumePPR = volumePPR;
    _this.costValueSDR = costValueSDR;
    _this.costValuePPR = costValuePPR;
    return _this;
  }

  return SalesDashboardComparatorRowDTO;
}(DomainObject_1.DomainObject);

exports.SalesDashboardComparatorRowDTO = SalesDashboardComparatorRowDTO;
/**
 * @inheritDoc
 */

SalesDashboardComparatorRowDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(SalesDashboardComparatorRowDTO.name);
  return {
    id: builder.id('id'),

    /** Additional row information */
    reportId: builder.str('reportId'),
    reportTime: builder.date('reportTime', DateParser_1.DateParser.ISO_PATTERN),
    categoryId: builder.str('categoryId'),

    /** {@link SalesDashboardComparatorItem} params */
    volumeDiff: builder.bigNum('volumeDiff'),
    costValueDiff: builder.bigNum('costValueDiff'),
    title: builder.str('title'),
    promoType: builder.senum('promoType', DashboardPromoType_1.DashboardPromoType, 'lookup-promo-type'),
    simulation: builder.bool('simulation'),
    volumeSDR: builder.bigNum('volumeSDR'),
    volumePPR: builder.bigNum('volumePPR'),
    costValueSDR: builder.bigNum('costValueSDR'),
    costValuePPR: builder.bigNum('costValuePPR')
  };
}();